module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0xii-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/F000J.jpg"
    }
  }), _vm._v("ust before dawn on April 9, 1940, Nazi Germany invaded Norway, a neutral and peace-loving country of only three million people. The Norwegians were completely unprepared for the onslaught of eight hundred aircraft, ten thousand advance troops, and almost the entire German navy. By noon, the Wehrmacht had taken control of Oslo, two major airports, and the most important coastal cities. The Norwegians scrambled to organize a military response, and for a few desperate weeks, aided by a small force of Allied troops, they put up a valiant but ultimately futile fight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some members of the government, including Vidkun Quisling, head of the Norwegian Nazi party, welcomed the Germans. Upon the invasion, Quisling quickly deposed the sitting government and declared himself prime minister.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In May, the Allied forces withdrew from Norway, and in early June, King Haakon and other members of the government left Norway for England and the Norwegian military disbanded. Nazi Germany was now occupying the country and was fully in control.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or "), _c('em', [_vm._v("were")]), _vm._v(" they?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("The occupying Germans had expected Norwegians to welcome them as their protectors against the Soviet Union. Fair-haired, blue-eyed, tall and fit, the Norwegians embodied the ideal of the Aryan race, which, according to Hitler, was destined to be the master race, and the Germans were unprepared for the hostility they encountered. An organized resistance formed almost immediately, including underground military groups (Milorg), civilian groups (Civorg), and intelligence units (XU), with a Coordinating Committee (KK) overseeing the common struggle. The movement was aided by a new British military branch called the SOE (Special Operatives Executive). But even ordinary Norwegians, young and old, found myriad ways of resisting. Despite an enormous military presence—one German soldier for every eight Norwegians—and in spite of the military’s brutal methods, so effective was this resistance that President Franklin D. Roosevelt was inspired to say to the American people:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('strong', [_vm._v("If there is anyone who still wonders why this war is being fought, let him look to Norway. If there is anyone who has any delusions that this war could have been averted, let him look to Norway; and if there is anyone who doubts the democratic will to win, again I say, let him look to Norway")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 78
// module chunks = 0